import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Table, Button, Space, message } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios'
import {
  GetStudentListForMandirAttendance,
  GetStudentListForAttendance,
  StudentAttendanceNight,
  StudentAttendanceMorning,
  SaveStudentMandirAttendance,
} from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import '../Masters/MasterCSS.css'

const { Option } = Select

export default function StudentMandirAttendance() {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [date, setDate] = useState(dayjs()) // today's date
  const [studentList, setStudentList] = useState([])
  const [loading, setLoading] = useState(false)

  // -----------------------------
  // Fetch attendance student list
  // -----------------------------
 const fetchStudents = async () => {
  setLoading(true)

  try {
    const res = await axios.get(
      `${GetStudentListForMandirAttendance}/${storedBranchId}/${BoardingYear}`,
    )

    const selectedDate = dayjs(date).format('YYYY-MM-DD')

    const formatted = res.data.map((item) => {
      let statusflag = '0'
      let disabledRow = false

      const todayAttendance = item.mandir_attendance?.find(
        (a) => a.attendance_date === selectedDate,
      )

      if (todayAttendance) {
        statusflag = todayAttendance.attendance_status?.toString() || '0'

         // Disable row if status is 1 or 2
        if (
          todayAttendance.attendance_status === 1 ||
          todayAttendance.attendance_status === 2
        ) {
          disabledRow = true
        }
        
      }

      return {
        reg_id: item.reg_id,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        room: item?.roombooking?.room?.room_no,
        bed: item?.roombooking?.bed?.bed_no,
        statusflag,
        disabledRow,        
      }
    })

    setStudentList(formatted)
  } catch (err) {
    toast.error('Failed to load student list.')
  }

  setLoading(false)
}


  useEffect(() => {
    if (date) fetchStudents()
  }, [date])

  // -----------------------------
  // Update individual attendance
  // -----------------------------
  const updateStatus = (id, flag) => {
    setStudentList((prev) =>
      prev.map((s) => (s.reg_id === id ? { ...s, statusflag: flag } : s)),
    )
  }

  // -----------------------------
  // Save Attendance
  // -----------------------------
 const handleSave = async () => {
  const pending = studentList.some((s) => s.statusflag === '0')
  if (pending) {
    toast.error('Please mark all students before saving.')
    return
  }

  const payload = {
    branch_id: parseInt(storedBranchId),
    year: BoardingYear,
    attendance_date: date.format('YYYY-MM-DD'),
    attendanceList: studentList.map((s) => ({
       reg_id: parseInt(s.reg_id),
       attendance_status: parseInt(s.statusflag),
    })),
  }

  try {
    const res = await axios.post(SaveStudentMandirAttendance, payload)

    if (res.data === 'MANDIRATTENDANCESAVED') {
      toast.success('Attendance saved successfully!')
    }
  } catch (err) {
    console.error(err)
    toast.error('Failed to save attendance.')
  }
}


  // -----------------------------
  // Table Columns
  // -----------------------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
      width: 70,
    },
    { title: 'Name', dataIndex: 'full_name' },
    { title: 'Room No', dataIndex: 'room', width: 100 },
    { title: 'Bed No', dataIndex: 'bed', width: 100 },

    {
      title: 'Attendance',
      dataIndex: 'statusflag',
      align: 'center',
      render: (flag, record) => (
        <Space>
          <Button
            primary
            type={flag === '1' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '1')}
          >
            P
          </Button>

          <Button
            danger
            type={flag === '2' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '2')}
          >
            A
          </Button>
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2 pb-3"></div>
        <div className="col-12 col-md-8 pb-3">
          <div className="header-row">
            <h2 className="page-title">Daily Mandir Attendance</h2>
          </div>

          {/* Filters */}
          <div className="d-flex gap-3 my-3" style={{ flexWrap: 'wrap' }}>
            <DatePicker
              value={date}
              format="DD-MM-YYYY"
              onChange={(d) => setDate(d)}
              disabledDate={(d) => d > dayjs()} // disable future dates
            />
          </div>

          {/* Table */}
          <Table
            columns={columns}
            dataSource={studentList}
            rowKey="student_id"
            loading={loading}
            pagination={{ pageSize: 10 }}
            bordered
            scroll={{ x: 'max-content' }}
            rowClassName={(record) =>
              record.disabledRow ? 'locked-attendance-row' : ''
            }
          />

          <div className="text-center mt-3">
            <Button type="primary" onClick={handleSave}>
              Save Attendance
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-2 pb-3"></div>
      </div>
    </div>
  )
}
